import { FC } from 'react';

import TableSkeleton from 'modules/_shared/components/Tables/TableSkeleton';
import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import { usePartnerOperations } from '../context/PartnerOperationsContext';
import PartnerOperationsTable from './PartnerOperationsTable';

const OperationsSectionBody: FC = () => {
  const { data, actions } = usePartnerOperations();

  const hasData = data.operations && data.operations.length > 0;
  const showPagination = hasData && data.totalOperations > data.rowsPerPage;

  return (
    <>
      {data.isLoading ? (
        <TableSkeleton
          rows={10}
          columns={5}
          showSubHeader={false}
          cardInner={false}
        />
      ) : (
        <div className="nk-block nk-block-lg">
          <PartnerOperationsTable />
        </div>
      )}

      {showPagination && (
        <TablePagination
          totalRows={data.totalOperations || 0}
          onChangePage={actions.handleChangePage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        />
      )}
    </>
  );
};

export default OperationsSectionBody;
